<template>
  <div id="app">
    <el-row>
      <el-col :span="12">
        <upload-file title="新模板" url="excel/template/new" />
      </el-col>
      <el-col :span="12">
        <upload-file title="老模板" url="excel/template/old" />
      </el-col>
    </el-row>

    <el-row style="margin-bottom: 20px;">
      <el-col :span="4">
        <el-input v-model="billOfLadingNumber" placeholder="提单号"> </el-input>
      </el-col>

      <el-col :span="4">
        <el-input v-model="weight" placeholder="重量"></el-input>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        <el-button type="primary" @click="testAxios">
          获取表格
        </el-button></el-col
      >
    </el-row>
    <!-- <el-table :data="list">
      <el-table-column
        label="additionalDeclarationType"
        prop="additionalDeclarationType"
      />
      <el-table-column label="additionalProcedure" prop="additionalProcedure" />
      <el-table-column
        label="commodityCodeCombinedNomenclatureCode"
        prop="commodityCodeCombinedNomenclatureCode"
      />
      <el-table-column label="consigneeCity" prop="consigneeCity" />
      <el-table-column label="consigneeCountry" prop="consigneeCountry" />
      <el-table-column label="consigneeID" prop="consigneeID" />
      <el-table-column label="consigneeName" prop="consigneeName" />
      <el-table-column label="consigneePostcode" prop="consigneePostcode" />

      <el-table-column
        label="consigneeStreetAndNr"
        prop="consigneeStreetAndNr"
      />
      <el-table-column label="consignorCity" prop="consignorCity" />
      <el-table-column label="consignorCountry" prop="consignorCountry" />
      <el-table-column label="consignorName" prop="consignorName" />
      <el-table-column label="consignorPostcode" prop="consignorPostcode" />
      <el-table-column
        label="consignorStreetAndNr"
        prop="consignorStreetAndNr"
      />
      <el-table-column label="countryOriginCode" prop="countryOriginCode" />
      <el-table-column label="customsProcedure" prop="customsProcedure" />
      <el-table-column label="declarationDate" prop="declarationDate" />
      <el-table-column label="declarationType" prop="declarationType" />
      <el-table-column label="descriptionGoods" prop="descriptionGoods" />
      <el-table-column label="goodsItemNumber" prop="goodsItemNumber" />
      <el-table-column label="grossMassKg" prop="grossMassKg" />
      <el-table-column label="incoterm" prop="incoterm" />
      <el-table-column label="invoiceCurrency" prop="invoiceCurrency" />
      <el-table-column label="ioss" prop="ioss" />
      <el-table-column label="lrn" prop="lrn" />
      <el-table-column label="netMassKg" prop="netMassKg" />
      <el-table-column label="numberPackages" prop="numberPackages" />
      <el-table-column label="totalPrice" prop="totalPrice" />
      <el-table-column label="trackingNumber" prop="trackingNumber" />
      <el-table-column label="typePackage" prop="typePackage" />
      <el-table-column label="unlocode" prop="unlocode" />


    </el-table> -->
  </div>
</template>

<script>
// import { huoquliebiao } from "@/api/importer";
import UploadFile from "@/components/UploadFile";
import XLSX from "xlsx";

export default {
  components: { UploadFile },

  data() {
    return {
      billOfLadingNumber: "",
      numbers: "",
      weight: "",
      list: [],
      tableData: [
        { name: "张三", age: 18, gender: "男" },
        { name: "李四", age: 20, gender: "女" },
        { name: "王五", age: 22, gender: "男" }
      ]
    };
  },
  created() {
    // this.testAxios();
  },
  methods: {
    exportData() {},
    testAxios() {
      this.$axios
        .get("http://39.108.13.114:9899/excel/getData", {
          params: {
            billOfLadingNumber: this.billOfLadingNumber,
            weight: this.weight
          }
        })
        .then(res => {
          console.log(res);
          const headers = [
            "declarationDate",
            "declarationType",
            "additionalDeclarationType",
            "customsProcedure",
            "additionalProcedure",
            "goodsItemNumber",
            "countryOriginCode",
            "consignorName",
            "consignorStreetAndNr",
            "consignorCity",
            "consignorPostcode",
            "consignorCountry",
            "consigneeName",
            "consigneeStreetAndNr",
            "consigneePostcode",
            "consigneeCity",
            "consigneeCountry",
            "consigneeID",
            "incoterm",
            "invoiceCurrency",
            "totalPrice",
            "unlocode",
            "netMassKg",
            "grossMassKg",
            "commodityCodeCombinedNomenclatureCode",
            "descriptionGoods",
            "typePackage",
            "numberPackages",
            "trackingNumber",
            "lrn",
            "ioss"
          ];
          res.data.dataInfo.forEach(element => {
            console.log(element);
          });
          console.log(res.data.dataInfo);
          const data = res.data.dataInfo.map(item => [
            item.declarationDate,
            item.declarationType,
            item.additionalDeclarationType,
            item.customsProcedure,
            item.additionalProcedure,
            item.goodsItemNumber,
            item.countryOriginCode,
            item.consignorName,
            item.consignorStreetAndNr,
            item.consignorCity,
            item.consignorPostcode,
            item.consignorCountry,
            item.consigneeName,
            item.consigneeStreetAndNr,
            item.consigneePostcode,
            item.consigneeCity,
            item.consigneeCountry,
            item.consigneeID,
            item.incoterm,
            item.invoiceCurrency,
            item.totalPrice,
            item.unlocode,
            item.netMassKg,
            item.grossMassKg,
            item.commodityCodeCombinedNomenclatureCode,
            item.descriptionGoods,
            item.typePackage,
            item.numberPackages,
            item.trackingNumber,
            item.lrn,
            item.ioss
          ]);
          const worksheet = XLSX.utils.aoa_to_sheet([headers, ...data]);
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
          XLSX.writeFile(workbook, "data.xlsx");

          // this.list = res.data.dataInfo;
          console.log(res);
        })
        .catch(err => {
          console.log(err);

          this.$message.error("创建失败: ");
        });
    }
  }
};
</script>
